import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../components/Loader';
import { Button } from '../../components/Button';
import { useAuthentication } from '../../shared/use-authentication';
import { useRouting } from '../../shared/use-routing';
import { pagePathnames } from '../page-routes';
import { GuestContactSupportForm } from '../../components/GuestContactSupportForm';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './AuthSignInPage.css';

function AuthSignInPage() {
    const { t } = useTranslation();
    const { location, parseLocationSearch, buildPath } = useRouting();
    const [isLoading, setIsLoading] = useState(true);
    const [isUnvalidLink, setIsUnvalidLink] = useState(false);
    const [isVisibleSupportForm, setIsVisibleSupportForm] = useState(false);
    const { token } = parseLocationSearch(location.search);
    const { signIn } = useAuthentication();

    const authorize = async () => {
        try {
            await signIn(token);
        } catch (e) {
            setIsUnvalidLink(true);

            throw e;
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            authorize();
        }
    }, [token]);

    useEffect(() => {
        if (isUnvalidLink) {
            logEvent(EVENT_TYPES.SIGN_IN_EXPIRED_LINK_VIEWED);
        }
    }, [isUnvalidLink]);

    if (isLoading) {
        return (
            <div className={styles.root}>
                <Loader variant='secondary' />
            </div>
        );
    }

    if (isUnvalidLink) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.form}>
                    <Button
                        iconLeft={{ name: 'chevronLeftFilled' }}
                        buttonProps={{ type: 'button', 'aria-label': t('common.goBack') }}
                        type='secondary'
                        link={{ to: buildPath(pagePathnames.signIn) }}
                        className={styles.buttonBack}
                    />
                    <h1 className={styles.title}>The Sign-In Link Has Expired</h1>
                    <p className={styles.subtitle}>No worries - get a new link below</p>
                    <Button
                        label='Email Me a New Link'
                        className={styles.button}
                        link={{ to: buildPath(pagePathnames.signIn) }}
                    />
                </div>
                <Button
                    label='Need Help signing in?'
                    type='secondary'
                    className={styles.buttonHelp}
                    size='big'
                    buttonProps={{ type: 'button' }}
                    onClick={() => setIsVisibleSupportForm(true)}
                />
                {isVisibleSupportForm && (
                    <GuestContactSupportForm
                        onClose={() => setIsVisibleSupportForm(false)}
                    />
                )}
            </div>
        );
    }

    return (
        <div className={styles.root}>
            <Loader variant='secondary' />
        </div>
    );
}

export {
    AuthSignInPage
};
